import { render, staticRenderFns } from "./oroi-proypotheseis.vue?vue&type=template&id=f60efa2c"
import script from "./oroi-proypotheseis.vue?vue&type=script&lang=js"
export * from "./oroi-proypotheseis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports